import type { ItemsDto } from '@/modules/common/dto/items.dto.ts';
import type { Page, PageParams } from '@/modules/common/types/page.type.ts';
import type { CounterpartyDto } from '@/modules/counterparty/dto/counterparty.dto.ts';
import type { Counterparty } from '@/modules/counterparty/types/counterparty.type.ts';

export class CounterpartyAdapter {
  private static map(response: CounterpartyDto): Counterparty {
    return {
      id: response.CLIENT_ID,
      parent: response.Родитель,
      number: response.Номер,
      type: response.Тип,
      legalForm: response.ПФ,
      name: response.Название,
      segment: response.Сегмент,
      region: response.Регион,
      priority: response.Приоритет,
      manager: response.Менеджер,
      city: response.Город,
      note: response.Примечание,
      createdAt: response.Создан,
    };
  }

  private static mapList(response: ItemsDto<CounterpartyDto>) {
    return response.items.map(CounterpartyAdapter.map);
  }

  static mapPage(response: ItemsDto<CounterpartyDto>, { offset, limit }: PageParams): Page<Counterparty> {
    return {
      offset,
      limit,
      count: response.count,
      items: CounterpartyAdapter.mapList(response),
    };
  }

  static legacy(response: CounterpartyDto): Counterparty {
    return CounterpartyAdapter.map(response);
  }
}
